import qs from 'qs';
import axios from 'axios';

import ENDPOINTS from 'tradera-constants/endpoints';
import { getCurrentLanguage } from 'tradera-lang/boot-languages';
import { toLocalizedUrl } from 'tradera-utils/url';
import {
    axiosWithTokenRefresh,
    finalizeResponse,
    handleError,
    API_ERRORS,
    axiosConfigs,
    checkResponseLoggedOut
} from 'tradera-utils/api';

export const getBids = async itemId => {
    return axiosWithTokenRefresh()
        .get(toLocalizedUrl(`/ajax/item/${itemId}/bids`, getCurrentLanguage()))
        .then(({ data }) => data)
        .catch(
            handleError({
                // Ignore 400 & 401 errors that slip through token refresh
                400: API_ERRORS.IGNORE_ME,
                401: API_ERRORS.IGNORE_ME
            })
        );
};

export const postFavoriteSeller = async (sellerId, isAlreadySaved) => {
    const payload = isAlreadySaved
        ? qs.stringify({ ids: sellerId })
        : qs.stringify({ sellerId: sellerId });
    return axios
        .post(
            isAlreadySaved
                ? ENDPOINTS.FAVORITE_SELLER_REMOVE
                : ENDPOINTS.FAVORITE_SELLER_ADD,
            payload,
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                ...axiosConfigs
            }
        )
        .then(checkResponseLoggedOut())
        .then(finalizeResponse())
        .catch(handleError());
};
